import { findMetatag } from "owa-metatags";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { isUrlPresent } from "owa-config";
import { getOrigin } from "owa-url/lib/getOrigin";
import { TOKEN_PRIORITY_EXO, TOKEN_PRIORITY_NOTIFICATION, TOKEN_PRIORITY_DEFAULT, } from "../const/constants";

function normalizeUrl(url: string): string {
    return url.toLowerCase().replace(/\/+$/, "");
}

export function getTokenRequestPriority(resource?: string): number {
    if (!isGlobalFeatureEnabled("auth-tokenQueuePriority", true)) {
        return TOKEN_PRIORITY_DEFAULT;
    }
    
    if (resource) {
        const normalizedResource = normalizeUrl(resource);
        const publicUrl = (findMetatag("publicUrl") || "").toLowerCase();
        if (isUrlPresent(publicUrl)) {
            if (normalizedResource === normalizeUrl(publicUrl)) {
                return TOKEN_PRIORITY_EXO;
            }
        }
        else if (normalizedResource === normalizeUrl(getOrigin())) {
            return TOKEN_PRIORITY_EXO;
        }
    }
    
    if (resource?.toLowerCase().endsWith("/notificationchannel")) {
        return TOKEN_PRIORITY_NOTIFICATION;
    }
    
    return TOKEN_PRIORITY_DEFAULT;
}
